import React, { useEffect, useRef, useState } from "react";
import { Alert, Snackbar } from "@mui/material";
import OTPInput from "otp-input-react";
import "./Emailverify.css";

// import { emailotpverify, otpverify } from "../../service/Authservice";
import { useLocation, useNavigate } from "react-router-dom";

const Emailverify = () => {
  const [otp, setotp] = useState(Number);
  const [open, setOpen] = useState(false);
  const [error, seterror] = useState(false);
  const [otperror, setotperror] = useState(false);
  const [load, setload] = useState();

  const navigate = useNavigate();
  const location = useLocation();
  const token = location.state?.token;
  const type = location.state?.type;
  const email = location.state?.email;

  const unshowref = useRef();

  useEffect(() => {
    // if (!token) {
    //   navigate("/SignUpemail");
    // }
    const handleClickOutside = (event) => {
      if (unshowref.current && !unshowref.current.contains(event.target)) {
        navigate("/");
      }
    };
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  // const handleverify = async () => {
  //   if (otp.length === 0) {
  //     setotperror("Required");
  //   } else if (otp.length !== 6) {
  //     setotperror("OTP must be 6 Characters");
  //   } else {
  //     setotperror("");
  //     setload(true);
  //     try {
  //       const data = await emailotpverify(otp, token);
  //       setload(false);
  //       navigate("/Register", {
  //         state: {
  //           type: type,
  //           email: email,
  //         },
  //       });
  //       setotp();
  //     } catch (error) {
  //       seterror(error.message);
  //       setOpen(true);
  //       setload(false);
  //     }
  //   }
  // };

  return (
    <>
      <div id="LoginRoot">
        <div className="Auth_details">
          <h1 className="Scanner_title">Enter OTP Code</h1>
          <OTPInput
            value={otp}
            onChange={setotp}
            className="Scanner_input"
            OTPLength={6}
            otpType="number"
            inputClassName="otp_input"
            resendOTP={{}}
          />
          <div className="validation_error">{otperror}</div>

          <p className="note_mark_title">Can't Recieve OTP?</p>
          <p className="note_mark">
            Please check your spam/junk mail to ensure OTP(authenticating your
            email) code
          </p>

          <button
            disabled={load}
            className="verify_submitbutton"
            // onClick={handleverify}
          >
            {load ? "Loading...." : "Submit"}
          </button>
        </div>
      </div>
      <Snackbar
        open={open}
        autoHideDuration={4000}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <Alert variant="filled" severity="error">
          {error}
        </Alert>
      </Snackbar>
    </>
  );
};
export default Emailverify;
